export function printTicketId(id) {
  let res = id.toString();

  while (res.length < 4) {
    res = '0' + res;
  }

  return '#' + res + ' - ';
}

export function printTicketInList(ticket) {
  let label = ticket.subject.substring(0, 30) + '...';
  return printTicketId(ticket.id) + label;
}
